import UserSignUp from "../models/UserSignUp";

const UserSignUpStore = UserSignUp.create();

export default UserSignUpStore;
